import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const NekretnineListPage = lazy(() => import('../pages/nekretnine/page'));
const SellerRepresentationPage = lazy(() => import('../pages/seller-representation/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const BlogFinancingGuidePage = lazy(() => import('../pages/blog/financing-guide/page'));
const BlogInflationAnalysisPage = lazy(() => import('../pages/blog/inflation-analysis/page'));
const BlogNewVsRenovationPage = lazy(() => import('../pages/blog/new-vs-renovation/page'));
const TermsOfUsePage = lazy(() => import('../pages/uvjeti-koristenja/page'));
const PrivacyGDPRPage = lazy(() => import('../pages/privatnost-gdpr/page'));
const CookiePolicyPage = lazy(() => import('../pages/politika-kolacica/page'));
const ComplaintFormPage = lazy(() => import('../pages/obrazac-za-prigovore/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/nekretnine',
    element: <NekretnineListPage />,
  },
  {
    path: '/besplatna-procjena-nekretnine-zagreb',
    element: <SellerRepresentationPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/blog/financiranje-nekretnine-zagreb',
    element: <BlogFinancingGuidePage />,
  },
  {
    path: '/blog/analiza-cijena-nekretnina-zagreb',
    element: <BlogInflationAnalysisPage />,
  },
  {
    path: '/blog/novogradnja-ili-adaptacija-zagreb',
    element: <BlogNewVsRenovationPage />,
  },
  {
    path: '/uvjeti-koristenja',
    element: <TermsOfUsePage />,
  },
  {
    path: '/privatnost-gdpr',
    element: <PrivacyGDPRPage />,
  },
  {
    path: '/politika-kolacica',
    element: <CookiePolicyPage />,
  },
  {
    path: '/obrazac-za-prigovore',
    element: <ComplaintFormPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
